import React from 'react'
import DocumentList from '../../Component/reusable_components/documents_list.js'
import { IMAGE_BASE_PATH_DBRALC } from '../../Config/Config'
import newsletter from '../../Assets/JSON/Alcnewsletter/alcnewsletter.json'

const ALCNewsletter = () => {
  return (
    <div>
      <DocumentList
        data={newsletter}
        title="ALC News Letter"
        basePath={IMAGE_BASE_PATH_DBRALC}
        iconPath="dbralc/News Letter/ALC-NL_Icon.svg"
        navigatePath="/alcnewsletter"
      />
    </div>
  )
}

export default ALCNewsletter
